export default __webpack_public_path__ + "static/media/create-folder.699163b4.svg";